import {
    LOAD_METRICS_FOR_OVERVIEW_CALL_BEGIN,
    LOAD_AT_RISK_AISLES_METRICS_FOR_OVERVIEW,
    LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_AISLE,
    LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_AISLE,
    LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER,
    LOAD_STOW_MIN_OF_WORK_METRICS_FOR_OVERVIEW_CLUSTER,
    LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_OVERVIEW_CLUSTER,
    LOAD_METRICS_FOR_OVERVIEW_CALL_FAILURE,
    FETCH_SMART_STOW_ENABLEMENT_CALL_SUCCESS
} from "../actions/OverviewActions";

/**
 * Initial state of the system.
 */
const initialState = {
    loading: true,
    isSmartStowEnabled: false,
    atRiskAislesMetricsMap:{},
    inductPackageMetricsMapAisle:{},
    inductPackageMetricsMapCluster:{},
    stowPackageMetricsMapAisle:{},
    minOfWorkMetricsMapCluster:{},
    stowPackageMetricsMapCluster:{},
    stowAssociateMetricsMapCluster:{}
}

/**
 * Reducer function for Overview View that changes state
 * based on the action triggered.
 */
export default function overviewReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_OVERVIEW_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_AT_RISK_AISLES_METRICS_FOR_OVERVIEW:
            return {
                ...state,
                loading: false,
                atRiskAislesMetricsMap: action.atRiskAislesMetricsMap
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_AISLE:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMapAisle: action.stowPackageMetricsMapAisle
            };
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER:
            return {
                ...state,
                loading: false,
                inductPackageMetricsMapCluster: action.inductPackageMetricsMapCluster
            };
        case LOAD_STOW_MIN_OF_WORK_METRICS_FOR_OVERVIEW_CLUSTER:
            return {
                ...state,
                loading: false,
                minOfWorkMetricsMapCluster: action.minOfWorkMetricsMapCluster
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMapCluster: action.stowPackageMetricsMapCluster
            };
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_OVERVIEW_CLUSTER:
            return  {
                ...state,
                loading: false,
                stowAssociateMetricsMapCluster: action.stowAssociateMetricsMapCluster
            };
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_AISLE:
            return {
                ...state,
                loading: false,
                inductPackageMetricsMapAisle: action.inductPackageMetricsMapAisle
            };
        case LOAD_METRICS_FOR_OVERVIEW_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        case FETCH_SMART_STOW_ENABLEMENT_CALL_SUCCESS:
            return {
                ...state,
                loading: false,
                isSmartStowEnabled: action.isSmartStowEnabled
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/OverviewReducer.js